module.exports = __webpack_public_path__ + "static/media/emergency.ad2f60d8.mp3";